import { TASKS_ORDER } from 'controllers/Homepage/Homepage'
import { Task, TrustNotification } from 'models'
import { selector, selectorFamily } from 'recoil'

import { taskQueueState, lastFetchUpdate, lastFetchInboxUpdate } from './atoms'
import { API_URL, fetchOptions } from './fetchUtils'

export const tasksQueueInfo = selector({
	key: 'tasksQueueInfo',
	get: ({ get }) => {
		const count = get(taskQueueState).length
		return { count }
	},
})
export const activeTask = selector({
	key: 'activeTask',
	get: ({ get }) => {
		return get(taskQueueState).find((t) => t.metadata.$active)
	},
})
export const getProcessParticipationFile = selectorFamily({
	key: 'processParticipationFile',
	get:
		(path) =>
		async ({ get }) => {
			const response = await get(fetchQuery(path))
			return response
				? response.docs.find(({ type }) => type.id === '4')
				: null
		},
})

export const fetchQuery = selectorFamily({
	key: 'fetchQueries',
	get:
		(path) =>
		async ({ get }) => {
			get(lastFetchUpdate(path))
			if (!path || path === '*') return null
			const response = await fetch(
				`${API_URL}/api${path.match(/^\//) ? path : `/${path}`}`,
				fetchOptions({})
			)
			if (response.status >= 400 && response.status !== 404) {
				if (response.status === 404) {
					return Promise.resolve(null)
				} else if (response.status === 401) {
					throw new TypeError(
						`${response.status}:${response.statusText}`
					)
				}
				try {
					const message = await response.text()
					throw new TypeError(`${response.status}:${message}`)
				} catch (e) {
					throw new TypeError(
						`${response.status}:Cannot get response from API.`
					)
				}
			}
			try {
				const data =
					response.ok && response.status !== 204
						? await response.json()
						: null
				return data
			} catch (e) {
				console.error('Invalid response for path:', path)
				return null
			}
		},
})

export const fetchTasks = selector({
	key: 'fetchTasks',
	get: async () => {
		const tasks_url = `${API_URL}/api/tasks/me`

		try {
			const tasks = await fetch(tasks_url, fetchOptions({})).then((r) =>
				r.json()
			)

			const tasksList = (tasks || []).map(Task.fromJSON)

			return tasksList.sort((a, b) => {
				const aType = a.subType || a.type || ''
				const bType = b.subType || b.type || ''

				const aIndex = TASKS_ORDER.findIndex((elem) => elem === aType)
				const bIndex = TASKS_ORDER.findIndex((elem) => elem === bType)

				return (
					(aIndex < 0 ? Number.MAX_SAFE_INTEGER : aIndex) -
						(bIndex < 0 ? Number.MAX_SAFE_INTEGER : bIndex) ||
					a?.dueDate?.timestamp - b?.dueDate?.timestamp
				)
			})
		} catch (error) {
			//TODO: Error handling
			throw new TypeError(`error`)
		}
	},
})

export const fetchInbox = selector({
	key: 'fetchInbox',
	get: async ({ get }) => {
		get(lastFetchInboxUpdate)
		const notifications_url = [`${API_URL}/api/notifications`]
		try {
			const notifications = await fetch(
				notifications_url,
				fetchOptions({})
			).then((r) => r.json())

			return {
				notifications: (notifications || []).map(
					TrustNotification.fromJSON
				),
			}
		} catch (error) {
			//TODO: Error handling
			throw new TypeError(`error`)
		}
	},
})
